"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var baseImage_1 = require("./baseImage");
var interior = {
    INTERIOR: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n\n    fragment Interior on Interior {\n      code @include(if: $dataLayer)\n      categoryCode @include(if: $dataLayer)\n      shortname\n      attributes {\n        oemcode\n      }\n      image {\n        ...BaseImage\n      }\n      price {\n        ...Price\n      }\n    }\n  "], ["\n    ", "\n\n    fragment Interior on Interior {\n      code @include(if: $dataLayer)\n      categoryCode @include(if: $dataLayer)\n      shortname\n      attributes {\n        oemcode\n      }\n      image {\n        ...BaseImage\n      }\n      price {\n        ...Price\n      }\n    }\n  "])), baseImage_1.default.BASE_IMAGE),
};
exports.default = interior;
var templateObject_1;
